import _ from 'lodash';

import staticText from '../../../../localization/Application/connect-config';

export const types = {
  FETCH_CONNECT_CONFIG_REQUEST: 'developer-client/configuration/FETCH_CONNECT_CONFIG_REQUEST',
  FETCH_CONNECT_CONFIG_SUCCESS: 'developer-client/configuration/FETCH_CONNECT_CONFIG_SUCCESS',
  FETCH_CONNECT_CONFIG_FAILURE: 'developer-client/configuration/FETCH_CONNECT_CONFIG_FAILURE',

  UPDATE_CONNECT_CONFIG_REQUEST: 'developer-client/configuration/UPDATE_CONNECT_CONFIG_REQUEST',
  UPDATE_CONNECT_CONFIG_SUCCESS: 'developer-client/configuration/UPDATE_CONNECT_CONFIG_SUCCESS',
  UPDATE_CONNECT_CONFIG_FAILURE: 'developer-client/configuration/UPDATE_CONNECT_CONFIG_FAILURE',

  SET_SELECTED_VEHICLE_ACCESS: 'developer-client/configuration/SET_SELECTED_VEHICLE_ACCESS',

  INITIALIZE_SELECTED_VEHICLE_ACCESS: 'developer-client/configuration/INITIALIZE_SELECTED_VEHICLE_ACCESS',
};

export const initialState = {
  connectConfig: {},
  selectedVehicleAccess: {},

  // fetching state
  isFetchingConnectConfig: false,

  // updating state
  isUpdatingConnectConfig: false,

  // fetching errors
  fetchingConnectConfigErrors: {
    connectConfig: '',
  },
};

export const actions = {
  fetchConnectConfigRequest: () => ({
    type: types.FETCH_CONNECT_CONFIG_REQUEST,
  }),
  fetchConnectConfigSuccess: data => ({
    type: types.FETCH_CONNECT_CONFIG_SUCCESS,
    payload: data,
  }),
  fetchConnectConfigFailure: err => ({
    type: types.FETCH_CONNECT_CONFIG_FAILURE,
    payload: err,
  }),

  updateConnectConfigRequest: data => ({
    type: types.UPDATE_CONNECT_CONFIG_REQUEST,
    payload: data,
  }),
  updateConnectConfigSuccess: data => ({
    type: types.UPDATE_CONNECT_CONFIG_SUCCESS,
    payload: data,
  }),
  updateConnectConfigFailure: err => ({
    type: types.UPDATE_CONNECT_CONFIG_FAILURE,
    payload: err,
  }),

  setSelectedVehicleAccess: (key, selectedValue) => ({
    type: types.SET_SELECTED_VEHICLE_ACCESS,
    payload: { key, selectedValue },
  }),

  initializeSelectedVehicleAccess: vehicleAccess => ({
    type: types.INITIALIZE_SELECTED_VEHICLE_ACCESS,
    payload: vehicleAccess,
  }),

};

export const selectors = {
  getConnectConfig: (state) => {
    return _.get(state, ['configuration', 'connectConfig']);
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CONNECT_CONFIG_REQUEST:
      return {
        ...state,
        fetchingConnectConfigErrors: {
          ...state.fetchingConnectConfigErrors,
          connectConfig: '',
        },
        isFetchingConnectConfig: true,
      };
    case types.FETCH_CONNECT_CONFIG_SUCCESS: {
      const updatedState = {
        ...state,
        connectConfig: action.payload,
        isFetchingConnectConfig: false,
      };

      return updatedState;
    }
    case types.FETCH_CONNECT_CONFIG_FAILURE:
      return {
        ...state,
        fetchingConnectConfigErrors: {
          ...state.fetchingConnectConfigErrors,
          connectConfig:
            (action.payload && action.payload.message) || staticText.errors.connectConfig,
        },
        isFetchingConnectConfig: false,
      };

    case types.UPDATE_CONNECT_CONFIG_REQUEST:
      return {
        ...state,
        fetchingConnectConfigErrors: {
          ...state.fetchingConnectConfigErrors,
          updatingConnectConfig: false,
        },
        isUpdatingConnectConfig: true,
      };
    case types.UPDATE_CONNECT_CONFIG_SUCCESS: {
      return {
        ...state,
        connectConfig: {
          ...state.connectConfig,
          ...action.payload,
        },
        // TODO: Uncomment when the rest of connect customizations is moved over
        // uploadedLogoUrl: action.payload.logoUrl,
        isUpdatingConnectConfig: false,
      };
    }
    case types.UPDATE_CONNECT_CONFIG_FAILURE:
      return {
        ...state,
        fetchingConnectConfigErrors: {
          ...state.fetchingConnectConfigErrors,
          updatingConnectConfig: true,
        },
        isUpdatingConnectConfig: false,
      };

    case types.INITIALIZE_SELECTED_VEHICLE_ACCESS:
      return {
        ...state,
        selectedVehicleAccess: action.payload,
      };

    case types.SET_SELECTED_VEHICLE_ACCESS: {
      const { key, selectedValue } = action.payload;

      const updatedList = new Set(state.selectedVehicleAccess[key]);

      if (updatedList.has(selectedValue)) {
        updatedList.delete(selectedValue);
      } else {
        updatedList.add(selectedValue);
      }

      return {
        ...state,
        selectedVehicleAccess: {
          ...state.selectedVehicleAccess,
          [key]: Array.from(updatedList),
        },
      };
    }

    default:
      return state;
  }
}
